import { API } from "aws-amplify";
import config from "./config";

export type Article = {
  createdAt?: number;
  slug?: string;
  title?: string;
  subTitle?: string;
  content?: string;
  blog?: string;
  toDeploy?: boolean;
  createdBy?: string;
  deployedAt?: number;
  deployedHash?: string;
  createdByUser?: boolean;
  illustrationHash?: string;
};

export const emptyArticleMeta: Article = {
  slug: "",
  title: "",
  subTitle: "",
  createdByUser: true,
  blog: config.defaultBlog,
};

export type Articles = {
  [key: string]: Article;
};

export const reducer = (
  state: Articles,
  action: { idToUpdate: string; articleToUpdate: Article }
) => ({ ...state, [action.idToUpdate]: action.articleToUpdate });

export const getArticlesAndProfilePictureFromDatabase = async (): Promise<{
  articles: Articles;
  profilePictureUrl?: string;
}> => {
  return API.post(config.apiName, "/getArticles", {});
};

export const getIllustrationPath = (
  articleId: string,
  illustrationHash: string
) => `${config.hostPrefix}/${articleId}.jpg?${illustrationHash}`;
